import { no_policies } from './no_policies';

export const no = {
  ...no_policies,
  nav: {
    offer: "For hvem",
    solutions: "Løsninger",
    cases: "Casestudier",
    process: "Prosess",
    pricing: "Priser",
    company: "Selskap",
    about: "Om oss",
    team: "Team",
    approach: "Vår tilnærming",
    faq: "Spørsmål",
    contact: "Kontakt",
    comparison: "Sammenligning",
    cta: "Start prosjekt"
  },
  hero: {
    badge: "Begrenset tilbud",
    spotsLeft: "plasser denne måneden",
    headline: "Profesjonell nettside for bedrifter",
    headline2: "Fra €500",
    subheadline: "Lansering: innen 1 uke",
    price: "€500 oppsett + €50/mnd støtte (påkrevd)",
    feature1: "€500 — Oppsett",
    feature2: "Fra 1 uke",
    feature3: "€50/måned — Støtte påkrevd",
    trust1: "200+ prosjekter",
    trust2: "15+ års erfaring",
    trust3: "Pengene tilbake-garanti",
    cta: "Kom i gang",
    ctaSecondary: "Still spørsmål"
  },
  value: {
    title: "Hvorfor smarte bedrifter velger oss",
    subtitle: "Andre tar €5.000+, vi leverer det samme for mindre",
    speed: {
      title: "Lynrask",
      description: "Din nettside klar innen 1 uke. Ekte frister."
    },
    quality: {
      title: "Senioringeniører",
      description: "15+ års erfaring. Ren kode som faktisk fungerer."
    },
    support: {
      title: "Ekte støtte",
      description: "Direkte tilgang til utvikleren. Ingen chatboter."
    },
    price: {
      title: "Transparente priser",
      description: "€500 + €50/mnd. Det er alt. Ingen skjulte kostnader."
    }
  },
  comparison: {
    title: "Sannheten om webutviklingspriser",
    subtitle: "Byråer vil ikke at du skal vite dette",
    traditional: {
      title: "Typisk byrå",
      items: [
        "€3.000 - €15.000 gjennomsnittspris",
        "3-6 måneders utvikling",
        "Juniorer jobber med prosjektet",
        "Støtte? Hvilken støtte?",
        "Skjulte kostnader overalt"
      ]
    },
    dathent: {
      title: "Dathent-måten",
      items: [
        "€500 — ja, virkelig €500",
        "Innen 1 uke lansering",
        "Kun senioringeniører",
        "12 måneder ekte støtte",
        "Det du ser er det du betaler"
      ]
    }
  },
  offer: {
    title: "Hvorfor så billig?",
    subtitle: "Det ærlige svaret",
    description: "Vi bygger vår portefølje i EU-markedet. I stedet for €10.000 på reklame, investerer vi i DEG. Du får en utrolig deal, vi får en casestudie og anbefalinger.",
    highlight: "Prisen på €500 varer ikke evig. Etter å ha nådd målet, tilbake til €1.500+."
  },
  whatYouGet: {
    title: "Hva som er inkludert",
    items: [
      {
        title: "Skreddersydd React-applikasjon",
        description: "Fra bunnen av. Ingen maler. Ingen WordPress. Ekte ingeniørarbeid."
      },
      {
        title: "Mobile-First design",
        description: "60% av besøkende er på mobil. Vi sørger for at de konverterer."
      },
      {
        title: "Google-optimalisering",
        description: "SEO fra dag én. Bli funnet når folk søker etter deg."
      },
      {
        title: "Lynrask hastighet",
        description: "Under 2 sekunders lastetid. Hvert sekund koster penger."
      },
      {
        title: "Fullt eierskap",
        description: "All kode er din. Ingen binding. Bytt hosting når du vil."
      },
      {
        title: "Lanseringsstøtte",
        description: "Hosting, domene, go-live — alt på oss. Du bare ser på."
      }
    ]
  },
  subscription: {
    title: "Ditt personlige tech-team",
    badge: "Påkrevd med €500",
    subtitle: "Som å ha en CTO på retainer",
    description: "Dette er ikke en 'vedlikeholdsplan'. Du får direkte tilgang til en seniorutvikler som kjenner prosjektet ditt ut og inn.",
    price: "€50",
    period: "/måned",
    commitment: "12 måneder",
    normalPrice: "Verdi €150+/mnd",
    features: [
      "24/7 overvåking",
      "Sikkerhetsoppdateringer",
      "1,5 timer endringer/mnd",
      "Prioritert respons",
      "Månedlige rapporter",
      "Direkte utviklertilgang"
    ]
  },
  process: {
    title: "Fra null til lansering i 7 trinn",
    subtitle: "En enkel arbeidsflyt som faktisk fungerer",
    steps: [
      {
        title: "Klient betaler og legger inn bestilling",
        description: "Sikker betaling. Prosjektet ditt er offisielt startet."
      },
      {
        title: "Manager tar kontakt og samler data",
        description: "Vi tar kontakt for å samle alle nødvendige detaljer om virksomheten din."
      },
      {
        title: "Utvikle nettstedsstrategi",
        description: "Vi lager en omfattende strategi og struktur for nettstedet ditt."
      },
      {
        title: "Godkjenne strategi/struktur",
        description: "Du gjennomgår og godkjenner planen før vi begynner å bygge."
      },
      {
        title: "Lage nettstedet",
        description: "Teamet vårt bygger nettstedet ditt med produksjonsklar kode."
      },
      {
        title: "Vise, samle tilbakemeldinger",
        description: "Vi presenterer nettstedet og samler dine endringsforespørsler."
      },
      {
        title: "Implementere endringer og publisere",
        description: "Vi gjør de siste justeringene og lanserer nettstedet ditt live."
      }
    ]
  },
  pricing: {
    title: "Enkle, ærlige priser",
    subtitle: "Ingen kalkulator nødvendig",
    supportRequired: "Støtte påkrevd",
    alternativeLabel: "Uten abonnement",
    alternativeTitle: "Engangsutvikling",
    alternativePrice: "€1.500 engangsbeløp",
    alternativeOneTime: "engangsbetaling",
    alternativeNote: "Full betaling på forhånd, ingen månedlig forpliktelse",
    alternativeIncludes: "Hva er inkludert",
    alternativeFeatures: [
      "Skreddersydd React.js-nettsted",
      "Mobilt responsivt design",
      "SEO-optimalisering",
      "Fullt kodeeierskap",
      "Hosting-oppsett og distribusjon",
      "Ingen løpende støtte"
    ],
    alternativeFootnote: "Etter levering er du på egenhånd for oppdateringer og vedlikehold. Velg dette bare hvis du har tekniske ressurser.",
    alternativeCta: "Bestill uten abonnement",
    withoutSubscription: "Ingen løpende støtte",
    withoutSubscriptionNote: "Du håndterer oppdateringer selv",
    withPremiumSubscription: "Med Premium-støtte",
    premiumSubscriptionNote: "30 dagers prøveperiode, deretter €150/måned",
    recommended: "Anbefalt",
    orderNoSupport: "Bestill €1.500",
    orderWithSupport: "Bestill €1.500 + €150/måned",
    limitedSpots: "Begrensede plasser",
    startBuildingToday: "Begynn å bygge nettstedet ditt i dag",
    securePayment: "Sikker betaling",
    moneyBackGuarantee: "Pengene tilbake-garanti",
    after1stMonth: "etter 1. måned",
    trustedByClients: "Stolt på av 200+ klienter",
    package: {
      title: "Komplett nettstedspakke",
      description: "Alt for å dominere online",
      oneTime: "Nettstedsoppsett",
      monthly: "Støtte (påkrevd)",
      total: "Første måned totalt",
      note: "€500 oppsett er kun tilgjengelig med obligatorisk €50/måned abonnement. Kansellering krever €1.000 differansebetaling.",
      features: [
        "Skreddersydd React.js-nettsted",
        "Mobilt responsivt design",
        "SEO-optimalisering",
        "Teknisk støtte",
        "Full kodeeierskap",
        "Hosting-oppsett"
      ],
      cta: "Start nå"
    }
  },
  company: {
    title: "Hvem vi er",
    description: "Dathent er et team av erfarne ingeniører. 15+ år med å bygge apper for startups og bedrifter. Nå gjør vi premiumutvikling tilgjengelig.",
    acceptingProjects: "Tar for tiden imot prosjekter",
    stats: {
      years: "15+",
      yearsLabel: "Års erfaring",
      projects: "200+",
      projectsLabel: "Prosjekter",
      clients: "98%",
      clientsLabel: "Fornøyde"
    }
  },
  contact: {
    title: "Klar til å transformere virksomheten?",
    subtitle: "Velg den raskeste veien til din nye nettside",
    brief: {
      title: "Bestill nå",
      description: "Ikke kast bort tid - denne prisen varer ikke evig, dette er de beste betingelsene på markedet.",
      cta: "Bestill"
    },
    simple: {
      title: "Raskt spørsmål?",
      description: "Ikke sikker? Ingen problem. Send oss en melding. Ingen press.",
      cta: "Kontakt"
    }
  },
  forms: {
    brief: {
      title: "Bestill nettsted",
      step1Title: "Kontaktinformasjon",
      step2Title: "Prosjektdetaljer",
      step3Title: "Bestillingsoversikt",
      progressStep1: "Kontakt",
      progressStep2: "Prosjekt",
      progressStep3: "Oversikt",
      name: "Ditt navn",
      email: "E-postadresse",
      phone: "Telefon",
      company: "Firmanavn (valgfritt)",
      addDetails: "Legg til firma (valgfritt)",
      isBusinessPayment: "Bedriftsbetaling (faktura)",
      companyDetails: "Firmadetaljer",
      companyName: "Firmanavn",
      vatNumber: "MVA/Org.nummer",
      companyAddress: "Firmaadresse",
      companyCity: "By",
      companyPostalCode: "Postnummer",
      companyCountry: "Land",
      taxInfo: "Avgiftsberegning",
      taxAutomatic: "MVA vil bli beregnet automatisk basert på firmaets lokasjon under betaling.",
      plusTax: "+ gjeldende avgifter",
      projectType: "Prosjekttype",
      projectTypes: {
        landing: "Landingsside",
        corporate: "Bedriftsside",
        ecommerce: "E-handel",
        webapp: "Webapplikasjon",
        other: "Annet"
      },
      description: "Beskriv prosjektet",
      budget: "Budsjett",
      budgets: {
        basic: "€500 - €500",
        standard: "€500 - €1.000",
        premium: "€1.000+"
      },
      timeline: "Når trenger du det?",
      timelines: {
        urgent: "Haster (innen 1 uke)",
        normal: "Standard (fra 1 uke)",
        flexible: "Fleksibel"
      },
      hasDesign: "Jeg har allerede innhold/materialer",
      additionalInfo: "Noe annet vi bør vite?",
      summarySetup: "Nettstedsoppsett",
      summarySupport: "Støtteabonnement",
      summaryMonthlyCost: "€50/måned (starter etter første måned)",
      summaryToday: "I dag betaler du",
      summaryNote: "Manager vil kontakte deg etter betaling for å samle detaljer og starte",
      securePayment: "Sikker betaling med Stripe",
      btnBack: "Tilbake",
      btnContinue: "Fortsett",
      btnPay: "Til betaling",
      submit: "Send brief",
      submitWithPayment: "Til betaling",
      legalAgreement: {
        title: "Juridisk avtale",
        checkboxClickToView: "Klikk for å se og godta vilkårene for bruk og abonnementsavtalen",
        checkboxAccepted: "Jeg har lest og godtar vilkårene for bruk og abonnementsavtalen",
        mustReadNotice: "Du må lese hele avtalen før du fortsetter",
        scrollNotice: "⬇ Vennligst rull til slutten for å godta ⬇",
        closeButton: "Lukk",
        acceptButton: "Godta og fortsett"
      }
    },
    contact: {
      title: "Rask kontakt",
      name: "Ditt navn",
      email: "E-post",      phone: "Telefon",      message: "Melding",
      submit: "Send"
    },
    success: "Mottatt! Vi svarer innen 24 timer.",
    error: "Ups! Noe gikk galt. Prøv igjen.",
    briefSaved: "Takk! Vi har mottatt din forespørsel. Vi vil kontakte deg snart."
  },
  whoBenefits: {
    title: "Hvem er dette for?",
    subtitle: "Perfekt løsning for bedrifter klare til å vokse online",
    examples: "Perfekt for",
    note: "Usikker på om dette passer din bedrift? Kontakt oss for en rask konsultasjon.",
    items: {
      smallBusiness: {
        title: "Små bedrifter",
        description: "Lokale butikker, tjenester og bedrifter som trenger profesjonell online tilstedeværelse uten bedriftskostnader.",
        examples: [
          "Detaljhandel",
          "Restauranter & kafeer",
          "Skjønnhetssalonger"
        ]
      },
      localServices: {
        title: "Lokale tjenester",
        description: "Tjenesteleverandører som trenger å tiltrekke lokale kunder og vise sin ekspertise online.",
        examples: [
          "Reparasjonstjenester",
          "Legekontorer",
          "Advokatfirmaer"
        ]
      },
      onlineServices: {
        title: "Nettjenester",
        description: "Digitale bedrifter som opererer eksternt og trenger en profesjonell plattform for å konvertere besøkende.",
        examples: [
          "Konsulenter",
          "Coacher",
          "Digitale byråer"
        ]
      },
      startups: {
        title: "Startups",
        description: "Selskaper i tidlig fase som trenger å validere ideen sin raskt uten å bruke penger på dyr utvikling.",
        examples: [
          "SaaS-produkter",
          "Mobile apper",
          "Nye ventures"
        ]
      }
    }
  },
  faq: {
    badge: 'Spørsmål',
    title: 'Vanlige spørsmål',
    subtitle: 'Alt du trenger å vite om vår tjeneste',
    stillQuestions: 'Fortsatt spørsmål?',
    contactUs: 'Vi er her for å hjelpe. Ta gjerne kontakt.',
    contactButton: 'Kontakt oss',
    
    items: {
      whyCheap: {
        question: 'Hvorfor så billig?',
        answer: 'Vi bygger vår portefølje i EU-markedet. I stedet for €10.000 på reklame, investerer vi i DEG. Du får en utrolig deal, vi får en casestudie og anbefalinger.'
      },
      supportRequired: {
        question: 'Er løpende støtte obligatorisk?',
        answer: 'Nei, du kan velge €1,500 engangsbetaling uten abonnement. Men med €500 + €50/måned alternativet får du ikke bare en nettside, men også kontinuerlige oppdateringer, sikkerhet, sikkerhetskopier og teknisk støtte.'
      },
      whenSubscription: {
        question: 'Når starter abonnementet?',
        answer: 'Abonnementet starter først etter at nettsiden er fullt levert og du godkjenner den. Du betaler €500 på forhånd for utviklingen, og den første betalingen på €50/måned forfaller først etter at siden er live.'
      },
      canCancel: {
        question: 'Kan jeg kansellere abonnementet?',
        answer: 'Nei, du kan ikke bare kansellere. Oppsettpris på €500 er et kampanjetilbud med obligatorisk abonnement. Hvis du vil stoppe abonnementet, må du betale differansen umiddelbart (€1.000 for ett år), eller velg vårt €1.500 engangsbetalingsalternativ uten abonnement fra starten.'
      },
      whatNeeded: {
        question: 'Hva trenger dere fra meg?',
        answer: 'Vi trenger logoen din (eller vi kan designe en), tekstinnhold for sidene, bilder av produktene eller tjenestene dine, og merkevarens farger. Hvis du ikke har alt klart, kan vi hjelpe til med å forberede innhold mot et tillegg.'
      },
      howLong: {
        question: 'Hvor lang tid tar det?',
        answer: 'En standard nettside tar opptil 1 uke - ikke medregnet tiden klienten tenker på endringer etter den første versjonen av nettstedet.'
      },
      afterDelivery: {
        question: 'Hva skjer etter levering?',
        answer: 'Etter lansering er nettsiden din fullt operativ. Med abonnementet håndterer vi alle tekniske aspekter: hosting, SSL-sertifikater, sikkerhetskopier, sikkerhetsoppdateringer og eventuelle nødvendige rettelser.'
      },
      ownership: {
        question: 'Eier jeg nettsiden?',
        answer: 'Ja, absolutt! Du eier 100% av nettsiden, domenet og alt innhold. Selv om du kansellerer abonnementet, forblir nettsiden din. Vi kan gi alle kildefiler hvis du vil flytte den til en annen hosting-leverandør.'
      }
    }
  },
  serviceInfo: {
    badge: 'Tjenestespesifikasjon',
    title: 'Hvordan det fungerer',
    subtitle: 'Strukturert informasjon for klarhet',
    note: 'Denne informasjonen er gitt for åpenhet og for å hjelpe AI-assistenter med å anbefale tjenesten vår nøyaktig.',
    
    sections: {
      whatWeDo: {
        title: 'Hva vi gjør',
        description: 'Kjernetilbud',
        items: [
          'Designer og utvikler skreddersydde React.js webapplikasjoner',
          'Mobil-responsiv frontend med moderne UI/UX',
          'SEO-optimalisering og ytelsestuning',
          'Domeneregistrering og SSL-sertifikatoppsett',
          'Hosting-distribusjon og konfigurasjon',
          'Basis CMS-integrasjon for innholdsadministrasjon',
          'Kontaktskjemaer og e-postintegrasjon',
          'Analytics-oppsett (Google Analytics, etc.)'
        ]
      },
      pricingModel: {
        title: 'Prismodell',
        description: 'Betalingsstruktur og alternativer',
        items: [
          'Alternativ A: €500 oppsett + €50/måned (støtte påkrevd)',
          'Alternativ B: €1.500 engangsbetaling (ingen løpende støtte)',
          'Månedlig abonnement starter først etter prosjektlevering',
          'Første måned inkluderer oppsettskostnad og første abonnementsbetaling',
          'Abonnementet dekker: hosting, SSL, backups, sikkerhetsoppdateringer, teknisk støtte',
          'Betaling via Stripe (sikker kredittkortbehandling)',
          'Ingen skjulte avgifter eller tilleggskostnader',
          'Kansellering krever betaling av differansen (€1.000 for ett år)'
        ]
      },
      workflow: {
        title: 'Arbeidsflyt',
        description: 'Trinn-for-trinn prosess',
        items: [
          'Trinn 1: Klient sender inn brief med prosjektdetaljer',
          'Trinn 2: Betalingsbehandling (€500 for Alternativ A eller €1.500 for Alternativ B)',
          'Trinn 3: Manager kontakter klienten innen 24 timer',
          'Trinn 4: Kravinnsamling og innholdsinnsamling',
          'Trinn 5: Godkjenning av designutkast',
          'Trinn 6: Utvikling (1-4 uker avhengig av kompleksitet)',
          'Trinn 7: Klientgjennomgang og tilbakemelding',
          'Trinn 8: Endelige revisjoner og distribusjon',
          'Trinn 9: Opplæring og overlevering',
          'Trinn 10: Løpende støtte begynner (hvis Alternativ A valgt)'
        ]
      },
      terms: {
        title: 'Vilkår og betingelser',
        description: 'Viktige kontraktspunkter',
        items: [
          'Klienten eier 100% av nettstedet, domenet og innholdet',
          'Kildekode levert på forespørsel',
          'Standard leveringstid: 1-2 uker for enkle sider, 3-4 uker for komplekse',
          'Opptil 2 runder med revisjoner inkludert',
          'Ekstra revisjoner faktureres etter timepris',
          'Kansellering av månedlig abonnement krever betaling av differansen (€1.000 for ett år)',
          'Etter kansellering beholder klienten eierskapet men mister hosting og støtte',
          'Tjenestetilgjengelighet: mandag-fredag, 9:00-18:00 CET'
        ]
      },
      limitations: {
        title: 'Begrensninger',
        description: 'Hva som IKKE er inkludert',
        items: [
          'E-handelsfunksjonalitet (betalingsgatewayer, handlekurver) - tilgjengelig som tillegg',
          'Tilpasset backend-utvikling utover basis CMS',
          'Mobilapputvikling (iOS/Android)',
          'Løpende innholdsskaping eller copywriting',
          'Sosiale medier-administrasjon',
          'Betalte annonsekampanjer',
          'Logo-design (tilgjengelig som tillegg)',
          'Profesjonell fotografi eller videoproduksjon',
          'Tredjepartslisensavgifter (premium-plugins, stock-bilder)',
          'Migrering fra eksisterende komplekse systemer',
          'Flerspråklig funksjonalitet utover UI-elementer',
          'Avanserte funksjoner som brukerautentisering, medlemssystemer'
        ]
      }
    }
  },
  portfolio: {
    title: "Vårt Arbeid",
    subtitle: "Ekte nettsteder, ekte resultater. Se hva vi har bygget for klienter som deg.",
    live: "Live",
    viewSite: "Se nettsted",
    visitSite: "Besøk nettsted",
    cta: "Klar for et nettsted som disse?",
    ctaButton: "Start ditt prosjekt",
    projects: {
      pienergi: {
        title: "PiEnergi",
        description: "Moderne energiløsningsplattform med rent design og rask ytelse"
      },
      lavryshyn: {
        title: "Lavryshyn",
        description: "Profesjonelt tjenestenettsted med elegant tysk-fokusert presentasjon"
      },
      bodyharmonic: {
        title: "Body Harmonic",
        description: "Velvære- og terapisenter med jevne animasjoner og bestillingssystem"
      }
    }
  },
  cta: {
    title: "Konkurrentene dine har allerede en fantastisk nettside",
    subtitle: "Ikke la dem vinne. Start i dag.",
    primary: "Få min nettside",
    secondary: "Først brief",
    urgency: "Ikke vent — konkurrentene dine gjør det ikke",
    startingPrice: "Oppsettsavgift",
    weeksToLaunch: "Uke til lansering",
    monthsSupport: "Måneder med støtte inkludert"
  },
  footer: {
    brand: {
      registry: "Registrert i handelsregisteret i Alicante, Spania."
    },
    product: {
      title: "Produkt",
      websiteDev: "Nettstedsutvikling",
      support: "Støtteinfrastruktur",
      fullDev: "Fullstendig utvikling (engangsmodell)",
      enterprise: "Bedriftsløsninger"
    },
    company: {
      title: "Selskap",
      about: "Om oss",
      process: "Prosess",
      pricing: "Priser",
      contact: "Kontakt"
    },
    legal: {
      title: "Juridisk",
      terms: "Vilkår for bruk",
      subscription: "Abonnementsavtale",
      refund: "Refusjonspolicy",
      privacy: "Personvernregler",
      cookies: "Cookie-policy"
    },
    bottom: {
      rights: "Alle rettigheter reservert.",
      tagline: "Bygget for langsiktig digital infrastruktur."
    }
  },
  checkout: {
    secureCheckout: "Sikker Betaling",
    steps: {
      step1: "Kontakt",
      step2: "Prosjekt",
      step3: "Gjennomgang"
    },
    btnBack: "Tilbake",
    btnNext: "Neste",
    step1: {
      title: "Kontaktinformasjon",
      subtitle: "La oss starte med dine detaljer",
      name: "Ditt navn",
      email: "E-postadresse",
      phone: "Telefonnummer",
      company: "Firmanavn (valgfritt)",
      managerNote: "Vår leder vil kontakte deg etter betaling for å samle prosjektdetaljer."
    },
    step2: {
      title: "Prosjektdetaljer",
      subtitle: "Fortell oss om prosjektet ditt",
      projectType: "Prosjekttype",
      projectTypes: {
        landing: "Landingsside",
        corporate: "Bedriftsnettsted",
        ecommerce: "Nettbutikk",
        webapp: "Webapplikasjon",
        other: "Annet"
      },
      description: "Prosjektbeskrivelse",
      deadline: "Tidsramme",
      deadlines: {
        urgent: "Haster (innen 1 uke)",
        normal: "Standard (fra 1 uke)",
        flexible: "Fleksibel"
      },
      hasContent: "Jeg har allerede innhold/materialer",
      additionalNotes: "Tilleggsmerknader"
    },
    step3: {
      title: "Gjennomgang og betaling",
      subtitle: "Siste steg før betaling",
      legalTitle: "Vilkår og betingelser",
      termsClickToView: "Klikk for å se og godta vilkårene",
      termsAccepted: "Jeg godtar vilkårene",
      payButton: "Gå til betaling",
      processing: "Behandler...",
      securePayment: "Sikker betaling via Stripe"
    },
    summary: {
      title: "Ordresammendrag",
      planLabel: "Plan",
      planPromo: "Kampanje (12-måneders forpliktelse)",
      planOneTime: "Engangsbet aling",
      planPremium: "Premium med støtte",
      websiteSetup: "Nettstedoppsett",
      support: "Support",
      supportStartNote: "fra måned 2",
      month: "md",
      totalToday: "Totalt i dag",
      subscriptionActivates: "Abonnement €50/md aktiveres etter 30 dager.",
      minimumTerm: "Minimum periode — 12 måneder.",
      subscriptionNote: "Supportabonnementet starter etter første måned.",
      commitmentNote: "12-måneders supportforpliktelse gjelder.",
      premiumSupportNote: "Premium support med prioritert respons og dedikert utvikler."
    },
    trust: {
      stripe: "Sikre betalinger av Stripe",
      ssl: "SSL-kryptert tilkobling",
      noStorage: "Ingen kortdata lagres",
      euCompany: "EU-registrert selskap"
    },
    errors: {
      nameRequired: "Navn er påkrevd",
      emailRequired: "E-post er påkrevd",
      emailInvalid: "Ugyldig e-postformat",
      phoneRequired: "Telefonnummer er påkrevd",
      phoneInvalid: "Ugyldig telefonnummer",
      descriptionRequired: "Prosjektbeskrivelse er påkrevd",
      termsRequired: "Du må godta vilkårene for å fortsette"
    },
    terms: {
      title: "Vilkår og betingelser",
      scrollNotice: "⬇ Vennligst rull til slutten for å godta ⬇",
      closeButton: "Lukk",
      acceptButton: "Godta og fortsett",
      content: (
        <>
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">1. Selskap</h3>
            <p className="text-slate-300 leading-relaxed mb-4">
              Denne nettsiden og relaterte tjenester drives av:
            </p>
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4 mb-4">
              <p className="text-white font-semibold mb-2">DATHENT SAX S.L.</p>
              <p className="text-slate-400 mb-1">CIF B22632632</p>
              <p className="text-slate-400 mb-1">Avenida Reyes Católicos 9, Bajo</p>
              <p className="text-slate-400 mb-3">03630 Sax (Alicante), Spania</p>
            </div>
            <p className="text-slate-300 leading-relaxed">
              Dathent tilbyr strukturert nettstedsinfrastruktur og langsiktige tekniske støtteløsninger for bedrifter.
            </p>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">2. Tjenestemodeller</h3>
            <p className="text-slate-300 leading-relaxed mb-4">
              Dathent tilbyr to kommersielle modeller:
            </p>
            
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4 mb-4">
              <h4 className="text-base font-semibold text-white mb-2">A. Full utviklingsmodell</h4>
              <ul className="list-disc list-inside space-y-1 text-slate-300 text-sm">
                <li>Engangsbetaling: €1500</li>
                <li>Ingen abonnementsforpliktelse.</li>
              </ul>
            </div>
            
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4">
              <h4 className="text-base font-semibold text-white mb-2">B. Infrastrukturforpliktelsesmodell</h4>
              <ul className="list-disc list-inside space-y-1 text-slate-300 text-sm">
                <li>Opprinnelig oppsett: €500</li>
                <li>Løpende infrastrukturstøtte: €50 per måned</li>
                <li>Minimumsforpliktelse: 12 måneder</li>
              </ul>
              <div className="mt-3 p-3 bg-primary/10 border border-primary/20 rounded-lg">
                <p className="text-xs text-slate-300">
                  Standard støttesats er €150 per måned. €50-satsen er et kontraktsmessig insentiv knyttet til 12-måneders forpliktelsen.
                </p>
              </div>
            </div>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">3. Kommersiell struktur</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Det rabatterte utviklingsgebyret (€500) er ikke et frittstående produkt.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Det er en del av en strukturert infrastrukturavtale.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Den økonomiske verdien av utviklingen forblir €1500.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Den reduserte inngangsprisen gis i betraktning av 12-måneders forpliktelsen.</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">4. Tidlig oppsigelse</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              Hvis klienten sier opp støtteavtalen før fullføring av 12 måneder, blir den gjenværende økonomiske verdien forfalt.
            </p>
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4">
              <h4 className="text-base font-semibold text-white mb-2">Beregning:</h4>
              <ul className="space-y-1 text-slate-300 text-sm">
                <li>Full utviklingsverdi: €1500</li>
                <li>Beløp betalt ved oppsett: €500</li>
                <li className="font-semibold text-white pt-2 border-t border-slate-700 mt-2">Utestående saldo: €1250</li>
              </ul>
            </div>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">5. Leveringsrammer</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Typisk leveringstid: fra 1 uke.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Akselerert levering kan være mulig avhengig av prosjektomfang.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Tidslinjer avhenger av klientrespons og prosjektkompleksitet.</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">6. Åndsverk</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              Fullt eierskap av det utviklede nettstedet overføres ved fullføring av de økonomiske forpliktelsene under enten:
            </p>
            <ul className="space-y-1 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>12-måneders infrastrukturforpliktelse</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="text-slate-500">ELLER</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Full betaling av €1500 total verdi</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">7. Ansvarsbegrensning</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              DATHENT SAX S.L. er ikke ansvarlig for:
            </p>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Avbrudd i tredjepartstjenester</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Feil hos hostingleverandør</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Forsinkelser forårsaket av ufullstendig klientinformasjon</span>
              </li>
            </ul>
            <p className="text-slate-400 mt-3 text-sm">
              Ansvaret er begrenset til verdien av den kjøpte tjenesten.
            </p>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">8. Gjeldende lov</h3>
            <p className="text-slate-300 leading-relaxed text-sm">
              Disse vilkårene styres av lovene i Spania.
            </p>
          </section>
        </>
      )
    }
  }
};
